import { APIFetchStudio, RequestHeaders } from "@certa/network";
import { useMutation, type UseMutationOptions } from "react-query";

export type AppJSONPatch =
  | {
      op: "create" | "update";
      path: string;
      value: any;
    }
  | {
      op: "delete";
      path: string;
    };

type StudioSaveIds = {
  app_settings: string;
  objects: string;
  processes: Record<string, string>;
};

export type UpdateAppJSONResponse = {
  message: string;
  __studio_save_ids: StudioSaveIds;
};

function updateAppJSON({
  branchSavepointId,
  payload
}: {
  branchSavepointId: number;
  payload: AppJSONPatch[];
}): Promise<UpdateAppJSONResponse> {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({ changes: payload })
  };

  return APIFetchStudio<UpdateAppJSONResponse>(
    `branch-savepoint/${branchSavepointId}/update-app-json/`,
    requestOptions
  );
}

type UpdateAppJSONError =
  | {
      error: string;
    }
  | {
      non_field_errors: string[];
    }
  | {
      changes: Record<string, string>;
    }
  | {
      details: string;
    };

export const useUpdateAppJSONMutation = (
  extraConfig?: UseMutationOptions<
    UpdateAppJSONResponse,
    UpdateAppJSONError,
    { branchSavepointId: number; payload: AppJSONPatch[] },
    unknown
  >
) => useMutation(updateAppJSON, extraConfig);
